import { msdyn365Commerce } from '@msdyn365-commerce/core-internal';

export interface IGtmItem {
    item_id?: string;
    item_name?: string;
    price?: number;
    quantity?: number;
    index?: number;
    item_list_name?: string;
    discount?: number;
}

export interface IGtmEcommerceData {
    currency?: string;
    value?: number;
    transaction_id?: string;
    tax?: number;
    shipping?: number;
    item_list_name?: string;
    items: IGtmItem[];
}

/**
 * Pushes a GA4 e-commerce event to the GTM dataLayer.
 * Handles SSR guard and ecommerce data clearing automatically.
 * @param event - The GA4 event name (e.g. 'view_item', 'add_to_cart').
 * @param ecommerce - The ecommerce data payload.
 */
export function pushGtmEvent(event: string, ecommerce: IGtmEcommerceData): void {
    if (!msdyn365Commerce.isBrowser) {
        return;
    }

    const dl = (window as any).dataLayer || [];
    dl.push({ ecommerce: null });
    dl.push({ event, ecommerce });
}
